































import Vue, { PropType } from "vue";
import { Spieler } from "models/Spieler";
import { DiscordMember } from "models/Discord";

export default Vue.extend({
	name: "AlertComp",
	props: {
		user: Object as PropType<Spieler>,
	},
	data: () => ({
		applicationInProgress: false,
		noDiscordFound: false,
		noApplication: false,
	}),
	created: function(): void {
		if (this.user == null) {
			return;
		}

		if (this.user.discord == null) {
			this.noDiscordFound = true;
			return;
		}

		if (this.user.role == 0) {
			let discord = this.user.discord as DiscordMember;
			if (discord.roles != null && discord.roles.length > 0) {
				// checking if the player has the open application role and no raider role, to determine whether or not any of the alerts should be shown.
				const hasApplicationRole = discord.roles.some(r => r.name == "offene bewerbung");
				const hasRaiderRoles = discord.roles.some(r => r.name.includes("raider"));
				this.applicationInProgress = hasApplicationRole;
				this.noApplication = !hasApplicationRole && !hasRaiderRoles;
			}
		}
	},
});
